<div class="section intro">
    {{ 'Libraries_explanation' | translate }}
</div>
<ng-container *ngIf="organization">
    <div class="section">
        <div class="title">{{ 'Exercices' | translate }}</div>
        <button *ngIf="canViewLibrary(LIBRARY_TYPE_EXERCISES_ELITMENT)"
                mat-button
                class="side-button"
                [disabled]="organization.id == conf.elitmentOrganizationId"
                [routerLink]="'/' + organization.code + '/libraries/' + organizationLibrary?.id + '/' + LIBRARY_TYPE_EXERCISES_ELITMENT">
            <span *ngIf="!userId && libraryType == LIBRARY_TYPE_EXERCISES_ELITMENT && currentLibraryId == organizationLibrary?.id && currentLibraryId != elitmentLibrary?.id" class="selected"></span>{{ 'Elitment_exercises' | translate }}
        </button>
        <button *ngIf="canViewLibrary(LIBRARY_TYPE_EXERCISES_SUPER_COACH)"
                mat-button
                class="side-button"
                [disabled]="organization.id == conf.elitmentOrganizationId"
                [routerLink]="'/' + organization.code + '/libraries/' + organizationLibrary?.id + '/' + LIBRARY_TYPE_EXERCISES_SUPER_COACH">
            <span *ngIf="!userId && libraryType == LIBRARY_TYPE_EXERCISES_SUPER_COACH && currentLibraryId == organizationLibrary?.id && currentLibraryId != elitmentLibrary?.id" class="selected"></span>{{ 'Super_coaches_exercises' | translate }}
        </button>
        <button *ngIf="canViewLibrary(LIBRARY_TYPE_EXERCISES)"
                mat-button
                class="side-button"
                [disabled]="organization.id == conf.elitmentOrganizationId"
                [routerLink]="'/' + organization.code + '/libraries/' + organizationLibrary?.id + '/' + LIBRARY_TYPE_EXERCISES">
            <span *ngIf="!myItems && libraryType == LIBRARY_TYPE_EXERCISES && currentLibraryId == organizationLibrary?.id && currentLibraryId != elitmentLibrary?.id" class="selected"></span>{{ 'Coaches_exercises' | translate:{organization: organization.name} }}
        </button>
        <button
                mat-button
                class="side-button"
                [disabled]="organization.id == conf.elitmentOrganizationId"
                [routerLink]="'/' + organization.code + '/libraries/' + organizationLibrary?.id + '/' + LIBRARY_TYPE_EXERCISES + '/personal'">
            <span *ngIf="myItems && libraryType == LIBRARY_TYPE_EXERCISES" class="selected"></span>{{ 'My_exercises' | translate }}
        </button>
    </div>
    <mat-divider></mat-divider>
    <div class="section">
        <div class="title">{{ 'Sessions' | translate }}</div>
        <button *ngIf="canViewLibrary(LIBRARY_TYPE_SESSIONS_ELITMENT)"
                mat-button
                class="side-button"
                [disabled]="organization.id == conf.elitmentOrganizationId"
                [routerLink]="'/' + organization.code + '/libraries/' + organizationLibrary?.id + '/' + LIBRARY_TYPE_SESSIONS_ELITMENT">
            <span *ngIf="libraryType == LIBRARY_TYPE_SESSIONS_ELITMENT && currentLibraryId == organizationLibrary?.id" class="selected"></span>{{ 'Elitment_sessions' | translate }}
        </button>
        <button *ngIf="canViewLibrary(LIBRARY_TYPE_SESSIONS_SUPER_COACH)"
                mat-button
                class="side-button"
                [disabled]="organization.id == conf.elitmentOrganizationId"
                [routerLink]="'/' + organization.code + '/libraries/' + organizationLibrary?.id + '/' + LIBRARY_TYPE_SESSIONS_SUPER_COACH">
            <span *ngIf="!myItems && libraryType == LIBRARY_TYPE_SESSIONS_SUPER_COACH" class="selected"></span>{{ 'Super_coaches_session' | translate:{organization: organization.name} }}
        </button>
        <button
                mat-button
                class="side-button"
                [disabled]="organization.id == conf.elitmentOrganizationId"
                [routerLink]="'/' + organization.code + '/libraries/' + organizationLibrary?.id + '/' + LIBRARY_TYPE_SESSIONS + '/personal'">
            <span *ngIf="myItems && libraryType == LIBRARY_TYPE_SESSIONS" class="selected"></span>{{ 'My_sessions' | translate }}
        </button>
    </div>
    <mat-divider></mat-divider>
    <div class="section">
        <div class="title">{{ 'Annual_plans' | translate }}</div>
        <button *ngIf="canViewLibrary(LIBRARY_TYPE_PLANS_ELITMENT)"
                mat-button
                class="side-button"
                [disabled]="organization.id == conf.elitmentOrganizationId"
                [routerLink]="'/' + organization.code + '/libraries/' + organizationLibrary?.id + '/' + LIBRARY_TYPE_PLANS_ELITMENT">
            <span *ngIf="libraryType == LIBRARY_TYPE_PLANS_ELITMENT && currentLibraryId == organizationLibrary?.id" class="selected"></span>{{ 'Elitment_plans' | translate }}
        </button>
        <button *ngIf="canViewLibrary(LIBRARY_TYPE_PLANS_SUPER_COACH)"
                mat-button
                class="side-button"
                [disabled]="organization.id == conf.elitmentOrganizationId"
                [routerLink]="'/' + organization.code + '/libraries/' + organizationLibrary?.id + '/' + LIBRARY_TYPE_PLANS_SUPER_COACH">
            <span *ngIf="!myItems && libraryType == LIBRARY_TYPE_PLANS_SUPER_COACH" class="selected"></span>{{ 'Super_coaches_plans' | translate:{organization: organization.name} }}
        </button>
        <button
                mat-button
                class="side-button"
                [disabled]="organization.id == conf.elitmentOrganizationId"
                [routerLink]="'/' + organization.code + '/libraries/' + organizationLibrary?.id + '/' + LIBRARY_TYPE_PLANS + '/personal'">
            <span *ngIf="myItems && libraryType == LIBRARY_TYPE_PLANS" class="selected"></span>{{ 'My_plans' | translate }}
        </button>
    </div>
</ng-container>
<mat-divider></mat-divider>
